<template>
  <!-- 小码王风格菜单 -->
  <header>
    <div :class="['menu-bar']">
      <a-row type="flex" justify="space-between">
        <a-col :span="2">
          <div class="logo">
            <router-link to="/"><img src="/img/logo.png" alt="" /></router-link>
          </div>
        </a-col>
        <a-col :span="10" class="notify">
          <a-carousel :dots="false" :autoplay="true" effect="fade">
            <a @click="showNotify(t)" v-for="(t, i) in notifys" :key="i"
              ><a-icon type="notification" theme="filled" />{{
                t.titile | ellipsis(20)
              }}</a
            >
          </a-carousel>
          <a-modal v-model="showNotifyModal" :title="notify.titile" ok-text="确认" cancel-text="取消" @ok="showNotifyModal=false">
            <div v-html="notify.msgContent">
            </div>
          </a-modal>
        </a-col>
        <a-col :span="12">
          <div class="login-btn-wrap">
            <a-menu mode="horizontal" class="user-menu">
              <a-sub-menu>
                <span slot="title" class="submenu-title-wrapper">
                  <router-link to="/student/center">
                    <a-avatar
                      style="backgroundcolor: #87d068"
                      icon="user"
                      :src="getQiniuUrl(userInfo.avatar) || '/img/avatar.png'"
                    />
                    {{ userInfo.realname }}
                    <a-icon type="down" />
                  </router-link>
                </span>
                <a-menu-item key="center:student">
                  <router-link to="/student/center">
                    <a-icon type="user" />个人中心
                  </router-link>
                </a-menu-item>
                <a-menu-item key="4" @click="updatePassword">
                  <a-icon type="setting" />
                  <span>密码修改</span>
                </a-menu-item>
                <a-menu-item key="center:logout">
                  <a @click="handleLogout" target="_blank"
                    ><a-icon type="poweroff" />退出登录</a
                  >
                </a-menu-item>
              </a-sub-menu>
              <a-menu-item>
                <div class="login-btn-wrap">
                  <router-link to="/student/course">去上课</router-link>
                </div>
              </a-menu-item>
              <a-sub-menu>
                <div slot="title" class="login-btn-wrap">
                  <a href="/scratch3/index.html?scene=create" target="_blank">去创作</a>
                </div>
                <a-menu-item key="create:scratch">
                  <a href="/scratch3/index.html?scene=create" target="_blank"
                    >图形化编程</a
                  >
                </a-menu-item>
                <a-menu-item key="create:turtle">
                  <a href="/onlinecode/index.html?lang=turtle" target="_blank"
                    >Python</a
                  >
                </a-menu-item>
                <a-menu-item key="create:jr">
                  <a href="/scratchjr/home.html" target="_blank"
                    >ScratchJr</a
                  >
                </a-menu-item>
              </a-sub-menu>
            </a-menu>
          </div>
        </a-col>
      </a-row>
    </div>
    <user-password ref="userPassword"></user-password>
  </header>
</template>
<script>
import Vue from "vue";
import store from "@/store";
import { ACCESS_TOKEN, TENANT_ID, USER_ROLE } from "@/store/mutation-types";
import { mapActions } from "vuex";
import UserPassword from "@/components/common/UserPassword";
import { getAnnountCement } from "@/api/sys";
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'

export default {
  name: "Menu",
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: { UserPassword },
  data() {
    return {
      showLogin: false,
      showRegister: false,
      userInfo: {},
      showMenu: true,
      notifys: [],
      notify:{},
      showNotifyModal: false
    };
  },
  created() {
    let that = this;
    this.userInfo = this.$store.state.user.info;
    console.log("用户信息：");
    console.log(this.userInfo);
    if (Vue.ls.get(USER_ROLE) == "teacher") {
      window.document.location = `/teacher`;
    }
    //需要登录的页面
    document.addEventListener("tokenInvaild", function (e) {
      // that.$router.push({
      //   path: `/user/login?role=student`,
      // });
      store.dispatch("Logout").then(() => {
        Vue.ls.remove(ACCESS_TOKEN);
        window.document.location = `/user/login?role=student`;
      });
    });
    getAnnountCement().then((res) => {
      this.notifys = res.result.records;
    });
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    ...mapActions(["Logout"]),
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              that.$router.push({ path: "/user/login?role=student" });
            })
            .catch((err) => {
              console.log(err);
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
    updatePassword() {
      let username = this.userInfo.username;
      this.$refs.userPassword.show(username);
    },
    showNotify(notify) {
      if (notify.href) {
        window.open(notify.href);
      } else {
        this.showNotifyModal = true
        this.notify = notify
      }
    },
  },
};
</script>
<style lang="less" scoped>
.menu-bar {
  width: 100%;
  padding: 9px 10%;
  background-color: @primary-color;
  transition: all 0.1s ease;
  // position: fixed;

  .logo {
    img {
      height: 50px;
    }
  }

  .notify {
    > div {
      display: inline-block;
      text-align: left;
      margin: 10px 5px;
      vertical-align: top;
    }
    .anticon {
      color: #fff;
      margin-right: 10px;
    }

    .ant-carousel {
      width: 90%;
      a {
        white-space: nowrap;
        color: #fff;
      }
    }
  }
  .menu {
    background: transparent;
    border-bottom: unset;
    .ant-menu-submenu,
    .ant-menu-item > a {
      font-size: 20px;
      font-weight: 700;
      color: white !important;
    }
    .ant-menu-submenu-active,
    .ant-menu-item-active {
      background: rgba(0, 0, 0, 0.2);
      // border-radius: 15px;
      border-bottom: none !important;
    }
  }
  .user-menu {
    background: transparent;
    border-bottom: unset;
    font-size: 18px;
    text-align: center;
    span {
      a {
        color: white;
        font-size: 14px;
      }
      .ant-avatar {
        font-size: 20px;
      }
    }

    .help-center a {
      font-size: 12px;
      color: #fff;
    }
    .login-btn-wrap {
      width: 100px;
      height: 48px;
      padding: 8px 5px;
      a {
        background: #fff;
        border-radius: 30px;
        display: block;
        font-size: 14px;
        text-align: center;
        color: @primary-color;
        line-height: 34px;
        font-weight: 700;
      }
    }
  }
}
</style>